export const getCollectionDetailsPageUrl = (collectionUUID: string) =>
	`/jira/polaris/roadmaps/${collectionUUID}/view`;

export const getCollectionViewPageUrl = (collectionUUID: string, viewUUID: string) =>
	`/jira/polaris/roadmaps/${collectionUUID}/view/${viewUUID}`;

export const getCollectionsPageUrl = () => '/jira/polaris/roadmaps';
